export default {
  title: 'Good news - you’re eligible!',
  paragraph:
    'Fill out our 5 minute form and you’ll get an instant decision on your loan.',
  emailSent:
    "We'll save your application as you go. " +
    "If you need to leave and come back to it at any point, use the link that we've sent to your email address.",
  firstName_error: 'Please fill in this field',
  lastName_error: 'Please fill in this field'
};
